/**
 * Staging environment switch.
 *
 * The staging build runs as a second container behind the same host/path as
 * production. HAProxy routes a request to the staging backend only when the
 * `vixgen_env=staging` cookie is present, so entering/leaving staging is just a
 * matter of setting or clearing that cookie and reloading. The cookie is merely a
 * routing hint — the staging backend independently enforces admin-only access.
 */
const STAGING_COOKIE = 'vixgen_env'

export function enterStaging(): void {
  const secure = window.location.protocol === 'https:' ? '; secure' : ''
  document.cookie = `${STAGING_COOKIE}=staging; path=/; max-age=2592000; samesite=lax${secure}`
  window.location.reload()
}

export function exitStaging(): void {
  document.cookie = `${STAGING_COOKIE}=; path=/; max-age=0; samesite=lax`
  window.location.reload()
}
